import { LoadingButton } from '@mui/lab'
import { Breakpoint, Stack } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import React from 'react'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: any
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

interface Props {
  open: boolean
  title?: string
  primaryButtonColor?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
  primaryButton?: boolean
  primaryButtonText?: string
  loading?: boolean
  maxWidth?: Breakpoint
  handleClose: () => void
  handleSubmit?: () => void
  children: any
}

export default function DialogConfirm({
  open,
  loading,
  title = '確認',
  maxWidth = 'sm',
  primaryButtonColor = 'primary',
  primaryButton = true,
  primaryButtonText = 'OK',
  children,
  handleClose,
  handleSubmit,
}: Props) {
  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={maxWidth}
        onClose={(_e, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={1}>{children}</Stack>
        </DialogContent>
        <DialogActions>
          <Stack
            width="100%"
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            mb={2}
          >
            <LoadingButton
              loading={loading}
              variant="outlined"
              color="inherit"
              size="small"
              sx={{
                px: 4,
              }}
              onClick={() => handleClose()}
            >
              戻る
            </LoadingButton>
            {primaryButton && (
              <LoadingButton
                loading={loading}
                color={primaryButtonColor}
                variant="contained"
                size="small"
                sx={{
                  px: 4,
                }}
                onClick={() => {
                  handleSubmit && handleSubmit()
                }}
              >
                {primaryButtonText}
              </LoadingButton>
            )}
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  )
}
